import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as VueGoogleMaps from "gmap-vue";
import VueScreen from "vue-screen";
import VueClosable from "vue-closable";
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: `UA-${process.env.VUE_APP_GTAG}` }
}, router);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_API_KEY,
    libraries: 'places',
  },
  installComponents: true,
});

Vue.use(VueScreen, 'bootstrap');
Vue.use(VueClosable);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
